import validate from "D:/Project/vue/frontend_new/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.19.23_eslint@8.57.0_less@4.2.0_rollup@4.17.2_sass@1.64.1_stylelint@_sdgmwjqs726rjjhhh4b7q4xeoi/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/Project/vue/frontend_new/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.19.23_eslint@8.57.0_less@4.2.0_rollup@4.17.2_sass@1.64.1_stylelint@_sdgmwjqs726rjjhhh4b7q4xeoi/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  blog: () => import("D:/Project/vue/frontend_new/src/middleware/blog.ts"),
  swap: () => import("D:/Project/vue/frontend_new/src/middleware/swap.ts")
}